import { apiRequest } from '../api/http'

export interface SupportContact {
  whatsappNumber: string | null
}

export function getSupportContact(): Promise<SupportContact> {
  return apiRequest<SupportContact>('/api', '/public/support', {
    skipSessionRefresh: true,
  })
}
